import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useT } from '~app/core/BundleProvider';
import withEnterToClick from '~app/core/withEnterToClick';
import { actions as CanvasActions } from '~app/features/canvas';

const ClickOrEnterDiv = withEnterToClick('div');

const ZoomButton = () => {
  const t = useT();
  const dispatch = useDispatch();
  const zoomToFit = useCallback(() => dispatch(CanvasActions.zoomToFit()), [
    dispatch,
  ]);
  return (
    <ClickOrEnterDiv
      className={`ZoomButton__button`}
      role="button"
      tabIndex="0"
      aria-label={t('recenter-zoom')}
      onClick={zoomToFit}
    >
      {t('recenter-zoom')}
    </ClickOrEnterDiv>
  );
};
export default ZoomButton;
